import React, { useState } from "react";
import styles from "../styles/VerticalNavigation.module.css";
import classNames from "classnames";
import {
  HomeOutlined,
  CodeOutlined,
  HeartOutlined,
  CommentOutlined,
} from "@ant-design/icons";

type TypeScroll = {
  onClickScroll: (segment: string) => void;
  stateActive: string;
};

const VerticalNavigation = ({ onClickScroll, stateActive }: TypeScroll) => {
  return (
    <div className={classNames(styles.containerNav, "sm:hidden")}>
      <div className={styles.wrapNavigation}>
        <div
          className={classNames(
            styles.buttonNavigation,
            stateActive === "about" ? styles.active : ""
          )}
          onClick={() => onClickScroll("about")}
        >
          <HomeOutlined
            className={classNames(
              styles.iconNav,
              stateActive === "about"
                ? styles.activeIconNav
                : styles.inactiveIconNav
            )}
          />
        </div>

        <div
          className={classNames(
            styles.buttonNavigation,
            stateActive === "dev" ? styles.active : ""
          )}
          onClick={() => onClickScroll("dev")}
        >
          <CodeOutlined
            className={classNames(
              styles.iconNav,
              stateActive === "dev"
                ? styles.activeIconNav
                : styles.inactiveIconNav
            )}
          />
        </div>

        <div
          className={classNames(
            styles.buttonNavigation,
            stateActive === "design" ? styles.active : ""
          )}
          onClick={() => onClickScroll("design")}
        >
          <HeartOutlined
            className={classNames(
              styles.iconNav,
              stateActive === "design"
                ? styles.activeIconNav
                : styles.inactiveIconNav
            )}
          />
        </div>

        <div
          className={classNames(
            styles.buttonNavigation,
            stateActive === "contact" ? styles.active : ""
          )}
          onClick={() => onClickScroll("contact")}
        >
          <CommentOutlined
            className={classNames(
              styles.iconNav,
              stateActive === "contact"
                ? styles.activeIconNav
                : styles.inactiveIconNav
            )}
          />
        </div>

        <div
          className={classNames(styles.animationNav, styles.startHome)}
        ></div>
      </div>
    </div>
  );
};

export default VerticalNavigation;
